import React, { useEffect, useState } from "react";
// import { Col, Row, Radio, Input, Checkbox, Form, Button } from "antd";
// import { getStyleProperties } from "../../../utils/CustomFunc";
import axios from "../../utils/BasicAuthAPI";
import Exam from "./Exam";
import ExamResult from "./ExamResult";
import ExamOTP from "./ExamOTP";
import "./exam.css";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const ExamDetail = (props) => {
  props.setPageHeader("Attend Exam");
  const history = useHistory();
  const urlCode = useSelector((state) => state.urlCode);
  const onFinish = (values) => {

  };
  const [examDetail, setExamDetail] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [result, setResult] = useState({ displayResult: false, result: null });
  const [loginError, setLoginError] = useState(false);

  const resultCallBack = (values) => {
    liracrypt
      .post("/exams/submitanswers?", values)
      .then(({ data }) => {
        setResult({ displayResult: true, result: data.data });
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const backToExam = () => {
    setExamDetail(null);
    setResult({ displayResult: false, result: null });
  };

  const formSubmitHandler = (values) => {
    liracrypt
      .get("/exams", { command: "fetch_questions", otp: values["OTP"] })
      .then(({ data }) => {
        if (data.isSuccess) {
          history.push(`/v02/${urlCode}${data.data.route}`);
          return;
        }
      })
      .catch(function (error) {
        setErrorMsg(
          error &&
            error.response &&
            error.response.data &&
            error.response.data.message
            ? error.response.data.message
            : "Invalid Otp!!!"
        );
        console.log("Error****:", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  return (
    <>
      <SessionError visible={loginError} />
      <React.Fragment>
        <div className="exam">
          {examDetail === null ? (
            <ExamOTP
              formSubmitHandler={formSubmitHandler}
              errroMsg={errorMsg}
            />
          ) : result.displayResult ? (
            <ExamResult result={result.result} backToExam={backToExam} />
          ) : (
            <Exam questions={examDetail} submitHandler={resultCallBack} />
          )}
        </div>
      </React.Fragment>
    </>
  );
};
export default ExamDetail;
